"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { CreateWaveDatesConfig, CreateWaveOutcomeConfig, CreateWaveOutcomeType } from "@/types/waves.types";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import CreateWaveOutcomeWarning from "../CreateWaveOutcomeWarning";
import PrimaryButton from "@/components/utils/button/PrimaryButton";
export default function CreateWaveOutcomesCICApprove(t0) {
  const $ = _c(51);
  const {
    waveType,
    dates,
    onOutcome,
    onCancel
  } = t0;
  const outcomeType = CreateWaveOutcomeType.NIC;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      type: outcomeType,
      title: null,
      credit: null,
      category: null,
      winnersConfig: null,
      maxWinners: null
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [outcome, setOutcome] = useState(t1);
  const [creditError, setCreditError] = useState(false);
  let t2;
  if ($[1] !== outcome) {
    t2 = e => {
      const newCredit = parseFloat(e.target.value);
      const isValid = !isNaN(newCredit) && newCredit >= 0;
      setOutcome({
        ...outcome,
        credit: isValid ? newCredit : null
      });
      setCreditError(false);
    };
    $[1] = outcome;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const setCredit = t2;
  let t3;
  if ($[3] !== outcome) {
    t3 = e_0 => {
      const newMaxWinners = parseInt(e_0.target.value);
      const isValid_0 = !isNaN(newMaxWinners) && newMaxWinners > 0;
      setOutcome({
        ...outcome,
        maxWinners: isValid_0 ? newMaxWinners : null
      });
    };
    $[3] = outcome;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const setMaxWinners = t3;
  let t4;
  if ($[5] !== onOutcome || $[6] !== outcome) {
    t4 = () => {
      const dontHaveCreditSet = !outcome.credit;
      setCreditError(dontHaveCreditSet);
      if (dontHaveCreditSet) {
        return;
      }
      onOutcome(outcome);
    };
    $[5] = onOutcome;
    $[6] = outcome;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const onSubmit = t4;
  let t5;
  if ($[8] !== outcome.credit) {
    t5 = outcome.credit !== null ? outcome.credit.toString() : "";
    $[8] = outcome.credit;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = `${creditError ? "tw-ring-error focus:tw-border-error focus:tw-ring-error tw-caret-error" : "tw-ring-iron-650 focus:tw-border-blue-500 focus:tw-ring-primary-400 tw-caret-primary-400"} ${outcome.credit ? "focus:tw-text-white tw-text-primary-400" : "tw-text-white"}  tw-form-input tw-block tw-px-4 tw-pt-3 tw-pb-4 tw-w-full tw-text-base tw-rounded-lg tw-border-0 tw-appearance-none tw-border-iron-600 tw-peer tw-bg-iron-900 focus:tw-bg-iron-900 tw-font-medium tw-shadow-sm tw-ring-1 tw-ring-inset placeholder:tw-text-iron-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset tw-transition tw-duration-300 tw-ease-out`;
  let t7;
  if ($[10] !== setCredit || $[11] !== t5 || $[12] !== t6) {
    t7 = <input type="text" value={t5} onChange={setCredit} id="outcome-cic-credit" autoComplete="off" className={t6} placeholder=" " />;
    $[10] = setCredit;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = `${creditError ? "peer-focus:tw-text-error" : "peer-focus:tw-text-primary-400"} tw-text-iron-500  tw-absolute tw-cursor-text tw-text-base tw-font-normal tw-duration-300 tw-transform -tw-translate-y-4 tw-scale-75 tw-top-2 tw-z-10 tw-origin-[0] tw-bg-iron-900 peer-focus:tw-bg-iron-900 tw-px-2 peer-focus:tw-px-2  peer-placeholder-shown:tw-scale-100 
              peer-placeholder-shown:-tw-translate-y-1/2 peer-placeholder-shown:tw-top-1/2 peer-focus:tw-top-2 peer-focus:tw-scale-75 peer-focus:-tw-translate-y-4 rtl:peer-focus:tw-translate-x-1/4 rtl:peer-focus:tw-left-auto tw-start-1`;
  let t9;
  if ($[14] !== t8) {
    t9 = <label htmlFor="outcome-cic-credit" className={t8}>NIC</label>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t7 || $[17] !== t9) {
    t10 = <div className="tw-group tw-w-full tw-relative">{t7}{t9}</div>;
    $[16] = t7;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== creditError) {
    t11 = creditError && <div className="tw-pt-1.5 tw-flex tw-items-center tw-gap-x-2"><svg className="tw-size-5 tw-flex-shrink-0 tw-text-error" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg><div className="tw-text-error tw-text-xs tw-font-medium">NIC must be a positive number</div></div>;
    $[19] = creditError;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11) {
    t12 = <div>{t10}{t11}</div>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== outcome.maxWinners) {
    t13 = outcome.maxWinners !== null ? outcome.maxWinners.toString() : "";
    $[24] = outcome.maxWinners;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  const t14 = `${outcome.maxWinners ? "focus:tw-text-white tw-text-primary-400" : "tw-text-white"} tw-ring-iron-650 focus:tw-border-blue-500 focus:tw-ring-primary-400 tw-caret-primary-400 tw-form-input tw-block tw-px-4 tw-pt-3 tw-pb-4 tw-w-full tw-text-base tw-rounded-lg tw-border-0 tw-appearance-none tw-border-iron-600 tw-peer tw-bg-iron-900 focus:tw-bg-iron-900 tw-font-medium tw-shadow-sm tw-ring-1 tw-ring-inset placeholder:tw-text-iron-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset tw-transition tw-duration-300 tw-ease-out`;
  let t15;
  if ($[26] !== setMaxWinners || $[27] !== t13 || $[28] !== t14) {
    t15 = <input type="text" value={t13} onChange={setMaxWinners} id="outcome-cic-max-winners" autoComplete="off" className={t14} placeholder=" " />;
    $[26] = setMaxWinners;
    $[27] = t13;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <label htmlFor="outcome-cic-max-winners" className={"peer-focus:tw-text-primary-400 tw-text-iron-500  tw-absolute tw-cursor-text tw-text-base tw-font-normal tw-duration-300 tw-transform -tw-translate-y-4 tw-scale-75 tw-top-2 tw-z-10 tw-origin-[0] tw-bg-iron-900 peer-focus:tw-bg-iron-900 tw-px-2 peer-focus:tw-px-2  peer-placeholder-shown:tw-scale-100 \n              peer-placeholder-shown:-tw-translate-y-1/2 peer-placeholder-shown:tw-top-1/2 peer-focus:tw-top-2 peer-focus:tw-scale-75 peer-focus:-tw-translate-y-4 rtl:peer-focus:tw-translate-x-1/4 rtl:peer-focus:tw-left-auto tw-start-1"}>Max Winners</label>;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t15) {
    t17 = <div><div className="tw-group tw-w-full tw-relative">{t15}{t16}</div></div>;
    $[31] = t15;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t12 || $[34] !== t17) {
    t18 = <div className="tw-grid md:tw-grid-cols-2 tw-gap-x-5 tw-pt-[0.5px]">{t12}{t17}</div>;
    $[33] = t12;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== dates || $[37] !== outcome.maxWinners || $[38] !== waveType) {
    t19 = <CreateWaveOutcomeWarning waveType={waveType} dates={dates} maxWinners={outcome.maxWinners} />;
    $[36] = dates;
    $[37] = outcome.maxWinners;
    $[38] = waveType;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== onCancel) {
    t20 = <button onClick={onCancel} type="button" className="tw-bg-iron-800 tw-border-iron-700 tw-text-iron-300 hover:tw-bg-iron-700 hover:tw-border-iron-700 tw-relative tw-inline-flex tw-items-center tw-justify-center tw-px-4 tw-py-3 tw-text-sm tw-font-semibold tw-border tw-border-solid tw-rounded-lg tw-transition tw-duration-300 tw-ease-out">Cancel</button>;
    $[40] = onCancel;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== onSubmit) {
    t21 = <PrimaryButton onClicked={onSubmit} disabled={false} loading={false} padding="tw-px-4 tw-py-3">Save</PrimaryButton>;
    $[42] = onSubmit;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t20 || $[45] !== t21) {
    t22 = <div className="tw-flex tw-justify-end tw-gap-x-3">{t20}{t21}</div>;
    $[44] = t20;
    $[45] = t21;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== t18 || $[48] !== t19 || $[49] !== t22) {
    t23 = <div className="tw-flex tw-flex-col tw-gap-y-6">{t18}{t19}{t22}</div>;
    $[47] = t18;
    $[48] = t19;
    $[49] = t22;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  return t23;
}